import { Action } from 'redux';

export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';
export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_FAILURE = 'VERIFY_EMAIL_FAILURE';
export const RESEND_VERIFICATION_REQUEST = 'RESEND_VERIFICATION_REQUEST';
export const RESEND_VERIFICATION_SUCCESS = 'RESEND_VERIFICATION_SUCCESS';
export const RESEND_VERIFICATION_FAILURE = 'RESEND_VERIFICATION_FAILURE';

export interface VerifyEmailRequestAction {
  type: typeof VERIFY_EMAIL_REQUEST;
}

export interface VerifyEmailSuccessAction {
  type: typeof VERIFY_EMAIL_SUCCESS;
  payload: any;
}

export interface VerifyEmailFailureAction {
  type: typeof VERIFY_EMAIL_FAILURE;
  payload: string;
}

export interface ResendVerificationRequestAction {
  type: typeof RESEND_VERIFICATION_REQUEST;
}

export interface ResendVerificationSuccessAction {
  type: typeof RESEND_VERIFICATION_SUCCESS;
  payload: any;
}

export interface ResendVerificationFailureAction {
  type: typeof RESEND_VERIFICATION_FAILURE;
  payload: string;
}

export interface UpdateProfileRequestAction extends Action<typeof UPDATE_PROFILE_REQUEST> {
  type: typeof UPDATE_PROFILE_REQUEST;
}

export interface UpdateProfileSuccessAction extends Action<typeof UPDATE_PROFILE_SUCCESS> {
  type: typeof UPDATE_PROFILE_SUCCESS;
  payload: any;
}

export interface UpdateProfileFailureAction extends Action<typeof UPDATE_PROFILE_FAILURE> {
  type: typeof UPDATE_PROFILE_FAILURE;
  payload: string;
}

export type ProfileActionTypes =
  | UpdateProfileRequestAction
  | UpdateProfileSuccessAction
  | UpdateProfileFailureAction
  | VerifyEmailRequestAction
  | VerifyEmailSuccessAction
  | VerifyEmailFailureAction
  | ResendVerificationRequestAction
  | ResendVerificationSuccessAction
  | ResendVerificationFailureAction;